import { ProFormaModelIds } from 'constants/proForma';
import { DetailsMetricId } from './metrics';
import { CardItemDescriptor, CardSectionDescriptor } from './cardTypes';
import { LayoutContext } from './types';

const item = (id: string, label: string, metric: DetailsMetricId): CardItemDescriptor<DetailsMetricId> => ({ id, label, metric });

const unitItems = ({ proFormaModelId }: LayoutContext): CardItemDescriptor<DetailsMetricId>[] => (
    proFormaModelId === ProFormaModelIds.APARTMENT ? [item('units', 'Units', 'units')] : []
);

export const detailsLayout = (context: LayoutContext): CardSectionDescriptor<DetailsMetricId>[] => [
    {
        id: 'details',
        title: 'Details',
        items: [
            item('address', 'Address', 'address'),
            item('coordinates', 'Coordinates', 'coordinates'),
            item('landArea', 'Land area', 'landArea'),
            item('far', 'FAR', 'far'),
            item('grossBuildableArea', 'Gross buildable area', 'grossBuildableArea'),
            item('buildings', 'Buildings', 'buildings'),
            item('stories', 'Stories', 'stories'),
            ...unitItems(context),
            item('grossBuiltSf', 'Gross Built SF', 'grossBuiltSf'),
            item('netRentableArea', 'Net Rentable Area', 'netRentableArea'),
            item('efficiencyRatio', 'Building efficiency ratio', 'efficiencyRatio'),
            item('parkingSpaces', 'Parking spaces', 'parkingSpaces'),
            item('parkingRatio', 'Parking ratio', 'parkingRatio'),
        ],
    },
    {
        id: 'description',
        title: 'Description',
        items: [item('description', 'Description', 'description')],
    },
];
